import type { FaireProductEntity } from "../../entity_types/product";

export const p_xfddwcynxv: FaireProductEntity = {
  token: "p_xfddwcynxv",
  type: "product",
  name: "Colombo Cereal Bowl Set of 2",
  brandToken: "b_dtfc7uc37e",
  brandName: "Aaron Probyn US",
  imageUrl: "https://cdn.faire.com/fastly/8c0db11111ba9121be4558e2e504acba912878ff0143e4f6000daf3364c17e5f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8f98657bd7880c257c1f3f8877b7e3e8fc641a67ad85479d7f7bb25ee1a2a980.jpeg",
    "https://cdn.faire.com/fastly/3c85bc784b19fc0d653673f6f25fd4393e5fcd5de5995eea7af7656ed4ca727c.jpeg",
    "https://cdn.faire.com/fastly/b73e0cd37a25445818a5e77bcb32d4639c189167cec3225f5b54f6d166e54829.jpeg",
    "https://cdn.faire.com/fastly/3b6b78f3a639fa0ff0860dd09ae5c148188e29d49f5425f2cb4aab2b4360eac5.jpeg",
    "https://cdn.faire.com/fastly/4c930b3ea3f8b74b53e150b46c1ffb7460b1c11e2170240ba1ca2ef9bc36f5eb.jpeg",
    "https://cdn.faire.com/fastly/67190d748bd4e3426e4edcdcbb415db611b3dcbd9f48432bc1d72c84cb0cc691.jpeg",
    "https://cdn.faire.com/fastly/1cc4168aa2d8b97a5a93dc935c7abc46cf2e884d58e42ad83ff0939415b8c2b7.jpeg",
    "https://cdn.faire.com/fastly/95d7f3aacaddbe34621ec57281592792d91cbc3c436094ae5296fc0c6e4fd937.jpeg",
    "https://cdn.faire.com/fastly/d50c55b538feb9a1f86d6bc9e5f7382ecf4c224c5571a2154c78043c4a393ba9.jpeg",
    "https://cdn.faire.com/fastly/edb7523487f33a8a2e2233565c77556dee52ab17aec317a075f04ba98521b52e.jpeg",
    "https://cdn.faire.com/fastly/904bba9a7fb2c3008e5972a5649f4134fd344ed04199dd177925c50e34446ce2.jpeg",
    "https://cdn.faire.com/fastly/2b81895d6d9f293852edb1782efe8007c174d2488bedf61e217aa43075c1fca0.jpeg"
  ],
  priceDollars: 25,
  description: "Colombo is a pleasing dinnerware range inspired by our love of sharing food with friends and family and creating memories around the table.\n\nThe well-considered collection of plates and bowls is perfect for hosting a dinner party for larger group and for making everyday meals for your loved ones special.\n\nColombo range allows you to be creative in how you set your table to best accompany your dishes, mood and needs.\n\nYou can match the colours across the range or mix them, to create your own unique set and add a curated eclectic feel to your table.\n\nBeautifully handcrafted from coloured porcelain – a superior strong and hardwearing ceramic, that if cared for, should last a lifetime. Dishwasher and microwave-safe.\n\nColombo cereal bowl is perfect for breakfast, desserts and serving dips, and tapas.\n\n• Material: Porcelain\n• Size: 14.5 x 6cm / 6.7 x 2.4\"\n• Set of 2",
  tags: [],
  msrpDollars: 50,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-04T23:53:33.907Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
